import * as OBC from "@thatopen/components";
import * as OBCF from "@thatopen/components-front";
import { delay } from "../../Shared/delay";
export const ResetPostProcessing = (components: OBC.Components, highlighter: OBCF.Highlighter, setResetHideIsolate: (value: boolean) => void) => {
    const hider = components!.get(OBC.Hider);
    hider.set(true);
    highlighter?.clear();
    setResetHideIsolate(true);
    delay(500).then(() => {
        setResetHideIsolate(false);
    });
}